import _ from 'lodash';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { color } from '@deerplusofficial/pos-helper';
import { ButtonBase, Icon } from '@deerplusofficial/pos-components';

const LINE_HEIGHT = '27px';

const Container = styled.div`
  display: flex;
  align-items: center;
  & + & {
    margin-top: 16px;
  }
`;

const Label = styled.div`
  color: ${color.text.title};
  white-space: nowrap;
  line-height: ${LINE_HEIGHT};
`;

const Value = styled.div`
  margin-left: auto;
  font-size: 18px;
  line-height: ${LINE_HEIGHT};
  ${props =>
    props.flex &&
    css`
      flex-grow: 1;
      max-width: 80%;
    `};
  ${props =>
    props.positive &&
    css`
      color: ${color.text.positive};
    `};
  ${props =>
    props.negative &&
    css`
      color: ${color.text.negative};
    `};
`;

const Addon = styled(ButtonBase)`
  padding-right: 24px;
`;

const AddonInner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  background-color: ${color.error};
  width: 20px;
  height: 20px;
  border-radius: 2px;
`;

export default class Info extends PureComponent {
  static propTypes = {
    label: PropTypes.string,
    positive: PropTypes.bool,
    negative: PropTypes.bool,
    flex: PropTypes.bool,
    addon: PropTypes.oneOf(['delete', false]),
    onAddonClick: PropTypes.func,
  };

  static defaultProps = {
    label: '',
    positive: false,
    negative: false,
    flex: false,
    addon: false,
    onAddonClick: _.identity,
  };

  render() {
    const {
      label,
      flex,
      positive,
      negative,
      addon,
      onAddonClick,
      children,
    } = this.props;

    return (
      <Container>
        {addon && (
          <Addon onClick={onAddonClick}>
            <AddonInner>
              <Icon icon="times" />
            </AddonInner>
          </Addon>
        )}
        <Label>{label}</Label>
        <Value flex={flex} positive={positive} negative={negative}>
          {children}
        </Value>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Info/Info.js